calculate = (testimony) => {
    const costs = {
        firstSheet: 3.005061,
        sheets: 0.601012,
        stampedSheet: 0.15,
        stamps: 0.45,
        normalApostille: 13.17,
        urgentApostille: 26.37,
        normalLegalization: 13.17,
        urgentLegalization: 26.37
    }

    let base = 0
    let honoraries = 0
    let apostilles = 0;
    let supplies = 0

    for (let i = 0; i < testimony.documents.length; i++) {
        //Extraigo las variables del documento
        const sheets = testimony.documents[i].sheets
        const whiteSheets = testimony.documents[i].whiteSheets
        const countries = {
            haya: testimony.documents[i].countries.haya,
            noHaya: testimony.documents[i].countries.noHaya
        }
        const urgent = testimony.documents[i].urgent

        //Calculo el total de los honorarios del testimonio
        const noBlankSheets = sheets - whiteSheets
        const whiteSheetsDiscount = whiteSheets > 0 ? whiteSheets / 2 : 0
        const totalSheets = noBlankSheets + whiteSheetsDiscount
        const apostilleSupplies = countries.haya > 0 ? urgent ? costs.urgentApostille : costs.normalApostille : 0
        const legalizationSupplies = countries.noHaya > 0 ? urgent ? costs.urgentLegalization : costs.normalLegalization : 0
        apostilles += apostilleSupplies + legalizationSupplies
        honoraries += totalSheets > 1 ? costs.firstSheet + costs.sheets * (totalSheets - 1) : costs.firstSheet
        base += apostilleSupplies + legalizationSupplies
        base += totalSheets > 1 ? costs.firstSheet + costs.sheets * (totalSheets - 1) : costs.firstSheet

        //Calculo el total de los suplidos
        const paperSupplies = (sheets + (whiteSheets > 0 ? 0 : 1)) * costs.stampedSheet
        const stampedSupplies = costs.stamps
        supplies += paperSupplies + stampedSupplies
    }

    return {
        base: parseFloat(base.toFixed(2)),
        honoraries: parseFloat(honoraries.toFixed(2)),
        apostilles: parseFloat(apostilles.toFixed(2)),
        supplies: parseFloat(supplies.toFixed(2))
    }
}
module.exports = calculate


// WEBPACK FOOTER //
// ./resources/assets/js/components/budgetary/testimonials/pricing.js